<template>
    <v-flex xs12>
      <v-card>
        <v-flex xs12 pt-4 px-4 v-if="err">
          <v-alert :value="true" type="error">{{err}}</v-alert>
        </v-flex>
        <v-card-title class="pb-3 px-2 layout row wrap">
          <v-btn class="primary my-0 mx-3" @click='$router.push({ name: "printTemplateCreate" })'>{{$lang.actions.createPrintTemplate}}</v-btn>
          <v-checkbox
            color="primary"
            class="mx-1 mt-0"
            :label="$lang.labels.showActive"
            v-model="showActive"
            hide-details
          />
          <v-spacer />
          <v-autocomplete
            class="min-w max-w mx-3 pb-2"
            :label="$lang.actions.selectCompany"
            :items="mappedCompanies"
            :loading="companyLoading"
            v-model="selectedCompany"
            hide-details
          />
          <v-text-field
            v-if="show"
            class="min-w max-w mx-3 pb-2"
            v-model="search"
            append-icon="search"
            :label="$lang.labels.search"
            hide-details
          />
        </v-card-title>
        <v-data-table
          v-if="show"
          :headers="headers"
          :items="showActive ? activeTemplates : allTemplates"
          :search="search"
          :loading="loading"
          :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
        >
          <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
          <template slot="items" slot-scope="props">
            <td>{{ props.item.templateName }}</td>
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.status }}</td>
            <td class="min-w-lg">
              <v-btn class="primary mx-0 elevation-1" @click="$router.push({ name: 'printTemplateClone', params: { id: props.item.id } })">{{$lang.actions.clone}}</v-btn>
              <v-btn class="primary elevation-1" @click="$router.push({ name: 'printTemplate', params: { id: props.item.id, view: true } })">{{$lang.actions.view}}</v-btn>
              <v-btn class="primary mx-0 elevation-1" @click="changeStatus(props.item)">{{props.item.status === 'active' ? $lang.actions.deactivate : $lang.actions.activate}}</v-btn>
            </td>
          </template>
          <v-alert slot="no-results" :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
</template>

<script>
  export default {
    data() {
      return {
        err: '',
        search: '',
        show: false,
        companyLoading: true,
        selectedCompany: '',
        companies: [],
        loading: true,
        headers: [
          { text: this.$lang.labels.name, value: 'templateName', align: 'left' },
          { text: this.$lang.labels.type, value: 'type', align: 'left' },
          { text: this.$lang.labels.status, value: 'status', align: 'left' },
          { text: this.$lang.labels.actions, value: 'actions', align: 'left', sortable: false },
        ],
        showActive: true,
        allTemplates: [],
      };
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      selectedCompany(val) {
        this.fetchTemplateforCompany(val);
        this.$cookie.set('companyedit', val, { expires: '8h' });
      },
    },
    computed: {
      activeTemplates() {
        const templates = this.allTemplates;
        const activeTemplates = [];
        for (let i=0; templates.length > i; i++) {
          if (templates[i].status === 'active' || templates[i].status === 'draft') {
            activeTemplates.push(templates[i]);
          }
        }
        return activeTemplates;
      },
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
    },
    methods: {
      changeStatus(template) {
        const action = template.status === 'active' ? 'deactivate' : 'activate';
        this.$http.post(`printtemplate/${action}/${template.id}`)
        .then((res) => {
          if (res.body.status === 'Success') {
            this.$set(template, 'status', action === 'activate' ? 'active' : 'inactive');
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.err = err.body.statusText || err.body.message;
        });
      },
      fetchTemplateforCompany(id) {
        this.show = true;
        this.templates = [];
        this.loading = true;
        this.$http.post('printtemplate/fetchall', { companyId: id })
          .then((res) => {
            this.loading = false;
            if (res.body.status === 'Success') {
              this.allTemplates = res.body.details;
              return;
            }
            if (this.templates.length === 0) {
              this.loading = false;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
          });
      },
    },
    created() {
      this.$http.get('company')
        .then((res) => {
          this.companyLoading = false;
          if (res.body.status === 'Success') {
            this.companies = res.body.companies;
            const edit = this.$cookie.get('companyedit');
            if (edit) this.selectedCompany = edit;
            return;
          }
          this.err = res.body.statusText;
        }, (err) => {
          this.companyLoading = false;
          this.err = err.body.statusText || err.body.message;
        });
    },
  };
</script>


// WEBPACK FOOTER //
// PrintTemplates.vue?195812b4